import React from 'react';
import PropTypes from 'prop-types';
import Colors from 'common/src/app/data/enum/Colors';
import { withFunctionalClassName } from 'common/src/app/util/componentClassNameUtils';
import { ProgressIndicator } from '@slimming-world/ui-library-components';
import ComponentType from 'common/src/app/data/enum/ComponentType';
import withDeviceState from 'common/src/app/util/device-state/withDeviceState';
import { DeviceState } from 'common/src/app/data/MediaQueries';
import Header from '../Header';
import PublicNavigationLinks from '../../molecules/PublicNavigationLinks';
import BackLink from '../../molecules/BackLink';
import Wrapper from '../../atoms/Wrapper';
import SlimmingWorldLogo from '../../atoms/SlimmingWorldLogo';

import './registration-template.scss';

const RegistrationTemplate = (
  { deviceState, publicHost, children, pageDetails, lastMountedStepIndex, groupRegistrationCTAs },
  _context,
  className,
) => (
  <div className={className}>
    <Header
      center={<SlimmingWorldLogo link={publicHost} />}
      bottom={
        pageDetails && (
          <>
            <BackLink labelVisible={deviceState > DeviceState.LG} />
            <ProgressIndicator
              className="progress-indicator"
              width={220}
              percent={Math.round((lastMountedStepIndex / pageDetails.length) * 100)}
            />
          </>
        )
      }
    >
      <PublicNavigationLinks />
    </Header>
    {children && (
      <Wrapper
        width="ls"
        background={Colors.PRIMARY_LIGHT}
        padding="xxl"
        cid="registration-content"
      >
        {children}
        {groupRegistrationCTAs && groupRegistrationCTAs}
      </Wrapper>
    )}
  </div>
);

RegistrationTemplate.propTypes = {
  children: PropTypes.node,
  deviceState: PropTypes.number,
  lastMountedStepIndex: PropTypes.number.isRequired,
  publicHost: PropTypes.string.isRequired,
  pageDetails: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  groupRegistrationCTAs: PropTypes.node,
};

RegistrationTemplate.defaultProps = {
  showNav: true,
};

export default withDeviceState()(
  withFunctionalClassName(ComponentType.ORGANISM, 'RegistrationTemplate')(RegistrationTemplate),
);
